// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HeaderItemStyle_profile_dropdown__Xv24Q {
  position: relative;
  display: flex;
  justify-content: flex-start;
}

.HeaderItemStyle_profile_ic__CFvU8 {
  cursor: pointer;
  color: var(--subheading);
  background: var(--bg-icon);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.HeaderItemStyle_dropdown_content__ahLJ- {
  position: absolute;
  top: calc(100% + 10px);
  background-color: #fff;
  border-radius: 6px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  z-index: 1;
  display: none;
  right: 8%;
  min-width: 150px;
}

.HeaderItemStyle_dropdown_content__ahLJ- ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.HeaderItemStyle_dropdown_content__ahLJ- li {
  color: #333; /* Set to a visible color */
  padding: 12px 20px;
  cursor: pointer;
  border-bottom: 1px solid var(--next-border-gradient-color);
}

.HeaderItemStyle_dropdown_content__ahLJ- li:hover {
  background-color: var(--body-bg-color);
}

/* Show dropdown when open class is applied */
.HeaderItemStyle_profile_dropdown__Xv24Q.HeaderItemStyle_open__oU3Xq .HeaderItemStyle_dropdown_content__ahLJ- {
  display: block;
}

/* pagination section  */

.HeaderItemStyle_paginationContainer__xqK7p {
  /* border: 1px solid red; */
  display: flex;
  align-items: center;
  font-size: 24px;
  padding: 10px 20px;
  gap: 10px;
  color: var(--text-color);
  /* cursor: pointer; */
}
.HeaderItemStyle_numbring__C9WUT {
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  outline: none;
  background-color: var(--secondary-color);
  border: none;
  color: var(--white-color);
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/Component/ReuseableComp/HeaderItemStyle.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,qDAAqD;EACrD,UAAU;EACV,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW,EAAE,2BAA2B;EACxC,kBAAkB;EAClB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,sCAAsC;AACxC;;AAEA,6CAA6C;AAC7C;EACE,cAAc;AAChB;;AAEA,wBAAwB;;AAExB;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,YAAY;EACZ,yBAAyB;EACzB,eAAe;AACjB","sourcesContent":[".profile_dropdown {\n  position: relative;\n  display: flex;\n  justify-content: flex-start;\n}\n\n.profile_ic {\n  cursor: pointer;\n  color: var(--subheading);\n  background: var(--bg-icon);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.dropdown_content {\n  position: absolute;\n  top: calc(100% + 10px);\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n  z-index: 1;\n  display: none;\n  right: 8%;\n  min-width: 150px;\n}\n\n.dropdown_content ul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.dropdown_content li {\n  color: #333; /* Set to a visible color */\n  padding: 12px 20px;\n  cursor: pointer;\n  border-bottom: 1px solid var(--next-border-gradient-color);\n}\n\n.dropdown_content li:hover {\n  background-color: var(--body-bg-color);\n}\n\n/* Show dropdown when open class is applied */\n.profile_dropdown.open .dropdown_content {\n  display: block;\n}\n\n/* pagination section  */\n\n.paginationContainer {\n  /* border: 1px solid red; */\n  display: flex;\n  align-items: center;\n  font-size: 24px;\n  padding: 10px 20px;\n  gap: 10px;\n  color: var(--text-color);\n  /* cursor: pointer; */\n}\n.numbring {\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  outline: none;\n  background-color: var(--secondary-color);\n  border: none;\n  color: var(--white-color);\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"profile_dropdown": `HeaderItemStyle_profile_dropdown__Xv24Q`,
	"profile_ic": `HeaderItemStyle_profile_ic__CFvU8`,
	"dropdown_content": `HeaderItemStyle_dropdown_content__ahLJ-`,
	"open": `HeaderItemStyle_open__oU3Xq`,
	"paginationContainer": `HeaderItemStyle_paginationContainer__xqK7p`,
	"numbring": `HeaderItemStyle_numbring__C9WUT`
};
export default ___CSS_LOADER_EXPORT___;
